import { render, staticRenderFns } from "./ReturnsPage.vue?vue&type=template&id=7d64399f&scoped=true"
import script from "./ReturnsPage.vue?vue&type=script&lang=js"
export * from "./ReturnsPage.vue?vue&type=script&lang=js"
import style0 from "./ReturnsPage.vue?vue&type=style&index=0&id=7d64399f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d64399f",
  null
  
)

export default component.exports